// ----------------------------------------------------------------------

export default function Typography(theme) {
	return {
		MuiTypography: {
			styleOverrides: {
				paragraph: {
					marginBottom: theme.spacing(2),
				},
				gutterBottom: {
					marginBottom: theme.spacing(1),
				},
			},
		},
		typography: {
			h1: {
				fontFamily: "Playfair Display, serif",
				fontSize: 16,
			},
		},
	};
}
